import { createSelector } from "@reduxjs/toolkit";

const selectWriter = (state) => state.visi.writer;

export const selectWriterSubject = (state) => selectWriter(state).subject;
export const selectWriterConversationKey = (state) =>
  selectWriter(state).conversationKey;
export const selectWriterConversationId = (state) =>
  selectWriter(state).conversationId;
export const selectWriterTitle = (state) => selectWriter(state).title;
export const selectWriterExchanges = (state) => selectWriter(state).exchanges;
export const selectWriterEpoch = (state) => selectWriter(state).epoch;
export const selectWriterView = (state) => selectWriter(state).view;
export const selectIsWriterUnavailable = (state) =>
  selectWriter(state).isUnavailable;
export const selectIsWriterNaming = (state) => selectWriter(state).isNaming;
export const selectIsOpeningWriterConversation = (state) =>
  selectWriter(state).isOpening;
export const selectWriterConversations = (state) =>
  selectWriter(state).conversations;
export const selectIsLoadingWriterConversations = (state) =>
  selectWriter(state).isLoadingConversations;
export const selectIsListingAllWriterPages = (state) =>
  selectWriter(state).isListingAllPages;
export const selectAreListedWriterConversationsFromAllPages = (state) =>
  selectWriter(state).areListedConversationsFromAllPages;
export const selectWriterConversationsError = (state) =>
  selectWriter(state).conversationsError;
export const selectWriterGrounding = (state) => selectWriter(state).grounding;
export const selectWriterComposerDocuments = (state) =>
  selectWriter(state).composerDocuments;
export const selectWriterComposerCollections = (state) =>
  selectWriter(state).composerCollections;
export const selectWriterPendingFirstSave = (state) =>
  selectWriter(state).pendingFirstSave;
export const selectWriterOpenRequestId = (state) =>
  selectWriter(state).openRequestId;
export const selectWriterRequestGeneration = (state) =>
  selectWriter(state).requestGeneration;

export const selectWriterBinding = (state) => {
  const writer = selectWriter(state);
  if (!writer.subject || !writer.conversationKey) {
    return null;
  }
  return Object.freeze({
    generation: writer.requestGeneration,
    conversationKey: writer.conversationKey,
    conversationId: writer.conversationId,
    documentId: writer.subject.documentId,
    editorView: writer.subject.editorView,
    promoteFromNew: writer.promoteFromNew,
  });
};

export const selectWriterInitialExchanges = createSelector(
  [selectWriterExchanges],
  (exchanges) =>
    exchanges.map((exchange) => ({
      turnRef: exchange.ref,
      question: exchange.question,
      answer: exchange.answer,
      citations: exchange.citations,
      clarificationAnswers: exchange.clarificationAnswers,
      groundedDocuments: exchange.groundedDocuments,
      groundedCollections: exchange.groundedCollections,
    }))
);

export const selectWriterReading = (state) => selectWriter(state).reading;

export const selectWriterReadingInitialExchanges = createSelector(
  [selectWriterReading],
  (reading) =>
    (reading?.exchanges ?? []).map((exchange) => ({
      turnRef: exchange.ref,
      question: exchange.question,
      answer: exchange.answer,
      citations: exchange.citations,
      clarificationAnswers: exchange.clarificationAnswers,
      groundedDocuments: exchange.groundedDocuments,
      groundedCollections: exchange.groundedCollections,
    }))
);
